import { Component, OnInit, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ApiService } from './../shared/api.service';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import { TweenMax } from 'gsap';
import { Tracking } from '../shared/tracking';
import { UploaderService } from '../shared/uploader.service';
import { DeleterService } from '../shared/deleter.service';
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { RutService } from '../shared/rut.service';
import { ValidatorService } from '../shared/validator-service.service';
import { rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { requiredFileType } from '../shared/requiredFileType.service';
import { GlobalConstants } from '../shared/global-constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import {interval, Observable, of, Subscription, timer} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {

  formData: FormGroup;
  submitted = false;
  pasos: any;
  respuesta: any;

  subscription!: Subscription;
  intentos = 0;
  
  public mimeTypes = ValidatorService.mimeTypes;

  @ViewChild('comuna') comuna: any;


  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private uploader: UploaderService,
    private deleter: DeleterService,
    private rutService: RutService,
    private spinner: NgxSpinnerService,
    private titleService: Title,
    private metaService: Meta,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private dialog: MatDialog,
  ) {
    // PASOS DE LA VISTA
    this.pasos = [{
      P1: {
        // *DevFun* Init
        I: true,
        CurrentNum: true
      },
      P2: {
        I: false,
        CurrentNum: false
      },
      P3: {
        I: false,
        CurrentNum: false
      }
    }];
  }

  ngAfterViewInit(){
    //@ts-ignore
    $('.videsk-top-container').css('display', 'none');
  }

  ngOnInit() {
    // CONTROLS FORMULARIO PASO 2
    this.formData = this.formBuilder.group({
      nAviso: ['', [Validators.required]],
      nCliente: ['', [Validators.required, Validators.maxLength(12), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator], [this.validarNumeroCliente.bind(this)]],
    });

    this.titleService.setTitle('Tracking | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'En esta sección puedes ver el estado' });

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.gotoPaso(1,null);
    }

  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  lightboxDiv(claseCss: string) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    this.spinner.show();
    this.submitted = true;
    console.log(this.formData);
    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      this.recaptchaV3Service.execute('SubmitTracking')
        .subscribe(
          (token) => {
            const tracking = new Tracking();
            tracking.numero_aviso = this.formData.value.nAviso;
            tracking.numero_cliente = this.formData.value.nCliente;
            tracking.token = token;

            const formulario = new FormData();
            formulario.append('data', JSON.stringify(tracking));

            this.apiService.AgregarTracking(formulario, tracking).subscribe(res => {
              this.respuesta = res;
              this.respuesta.numero_cliente = this.formData.value.nCliente;
              this.respuesta.numero_aviso = this.formData.value.nAviso;
              if (res.respuesta === true) {
                if( res.ConsultarEstadoAvisoPorElementosResponse.Mensajes.item.CodMensaje === '502'){
                  this.lightboxDiv('.modal-error-aviso');
                }else{
                  this.gotoPaso(4, res);
                }
              }
              else {
                this.lightboxDiv('.modal-error');
              }
              this.spinner.hide();
            });
          },
          (error) => {
            this.lightboxDiv('.modal-error');
            this.spinner.hide();
          },
        );
    }
  }

  onReset() {
    this.submitted = false;
    this.formData.reset();
  }

  gotoPaso(index: any, respuesta: any) {
    switch (index) {
      case 1:
        this.pasos[0].P1.I = true;
        this.pasos[0].P2.I = false;
        this.pasos[0].P3.I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0].P1.CurrentNum = true;
            this.pasos[0].P2.CurrentNum = false;
            this.pasos[0].P3.CurrentNum = false;
            $('.paso-1')[0].scrollIntoView();
          }
        });
        break;
      case 2:
        this.pasos[0].P1.I = false;
        this.pasos[0].P2.I = true;
        this.pasos[0].P3.I = false;
        TweenMax.to('.linea-current', 0.5, {
          width: '50%', onComplete: () => {
            this.pasos[0].P1.CurrentNum = true;
            this.pasos[0].P2.CurrentNum = true;
            this.pasos[0].P3.CurrentNum = false;
            $('.paso-2')[0].scrollIntoView();
          }
        });
        break;
        case 3:
          this.spinner.show();
          const source = interval(2000);
          this.subscription = source.subscribe(val => {
            this.apiService.LeerAviso(respuesta.idTransaccion).subscribe( aviso => {
              if( aviso != null && aviso !== 'null'){
                 this.subscription.unsubscribe();
                 this.gotoPaso(4, aviso);
                 this.spinner.hide();
                 this.intentos = 0;
              }
              else if ( this.intentos >= GlobalConstants.reintentosSolicitud){
                this.lightboxDiv('.modal-error');
                this.subscription.unsubscribe();
                this.spinner.hide();
                this.intentos = 0;
              }else{
                this.intentos++;
              }
            },
            err => {
              console.log('ERROR: ' + err);
            }
            );

          });
          break;
        case 4:
          // Acá se debe procesar la respuesta y mandarla al componente <app-suscripcion-boleta-satisfactoria>
          //this.pasos[0]['P1'].I = false;
          this.pasos[0]['P2'].I = false;
          this.pasos[0]['P3'].I = true;
          // Acá se muestra el componente de respuesta
          this.respuesta = respuesta;
          
          $("app-boleta").show();
          TweenMax.to('.linea-current', 1, {
            width: '100%', onComplete: () => {
              this.pasos[0]['P2'].CurrentNum = true;
              this.pasos[0]['P3'].CurrentNum = true;
              $(".paso-3")[0].scrollIntoView();
            }
          });
          break;
    }
  }

  validarNumeroCliente(
    control: AbstractControl
  ): Observable<{ [key: string]: any } | null> {
    if (control.value === null || control.value.length === 0) {
      return of(null);
    } else {
      this.spinner.show();
      return timer(0).pipe(
        switchMap(() => {
          return this.apiService.checkCliente(control.value).pipe(
            map(res => {
              if (res.respuesta) {

                this.spinner.hide();
                return null;
              }else{
                this.lightboxDiv('.modal-error-cliente');
              }
              // SI ES INCORRECTO LIMPIAR
              this.spinner.hide();
              return { numClienteExist: true };
            })
          );
        })
      );
    }
  }
}
